import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { mbtiResults } from '../data/results';
import AdBanner from './AdBanner';

function ResultPage() {
  const location = useLocation();
  // 결과 데이터 가져오기
  const { mbtiResult = "ISFP" } = location.state || {};
  console.log("결과 페이지에서 받은 MBTI:", mbtiResult);
  
  // mbtiResults에서 결과 찾기
  const result = mbtiResults[mbtiResult] || mbtiResults["ISFP"]; // 기본값 설정

  // 결과 공유 기능을 테스트 공유 기능으로 수정
  const shareResult = async () => {
    // 메인 페이지 URL 생성
    const mainPageUrl = window.location.origin;
    
    if (navigator.share) {
      try {
        // 웹 공유 API 사용 (모던 모바일 브라우저)
        await navigator.share({
          title: `MBTI 성격유형 테스트`,
          text: `나의 MBTI 유형을 알아보는 테스트를 해보세요!`,
          url: mainPageUrl,
        });
      } catch (error) {
        console.error("공유 중 오류 발생:", error);
        // 공유 API 실패 시 클립보드 자동 복사
        copyToClipboard(mainPageUrl);
      }
    } else {
      // 웹 공유 API를 지원하지 않는 경우 클립보드 자동 복사
      copyToClipboard(mainPageUrl);
    }
  };

  // 클립보드 자동 복사 기능
  const copyToClipboard = async (url) => {
    try {
      // 1. 현대적인 navigator.clipboard API 시도
      await navigator.clipboard.writeText(url);
      alert("MBTI 테스트 URL이 클립보드에 복사되었습니다!");
    } catch (error) {
      console.error("클립보드 복사 중 오류 발생:", error);
      
      try {
        // 2. 대체 클립보드 복사 방법 시도 (더 넓은 호환성)
        const textArea = document.createElement("textarea");
        textArea.value = url;
        textArea.style.position = "fixed";  // 화면 밖에 위치
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        
        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        
        if (successful) {
          alert("MBTI 테스트 URL이 클립보드에 복사되었습니다!");
        } else {
          alert("URL 복사에 실패했습니다. 아래 주소를 직접 복사해주세요:\n" + url);
        }
      } catch (err) {
        alert("URL 복사에 실패했습니다. 아래 주소를 직접 복사해주세요:\n" + url);
      }
    }
  };

  return (
    <div className="container mt-5">
      <div className="card mb-4">
        <div className="card-header bg-primary text-white text-center">
          <h1 className="display-4">당신의 MBTI는 {mbtiResult}!</h1>
          <h2>{result.title}</h2>
        </div>
        
        <div className="card-body">
          <div className="mb-4">
            <h3>성격 특징</h3>
            <p className="lead">{result.description}</p>
          </div>
          
          <div className="row mb-4 g-4">  {/* g-4 클래스 추가 - 그리드 아이템 사이 간격 */}
            <div className="col-md-6 mb-4 mb-md-0">  {/* 모바일에서만 아래 마진 적용 */}
              <h4>강점</h4>
              <ul className="list-group">
                {result.strengths.map((strength, index) => (
                  <li key={index} className="list-group-item">{strength}</li>
                ))}
              </ul>
            </div>
            
            <div className="col-md-6">
              <h4>약점</h4>
              <ul className="list-group">
                {result.weaknesses.map((weakness, index) => (
                  <li key={index} className="list-group-item">{weakness}</li>
                ))}
              </ul>
            </div>
          </div>
          
          <div className="mb-4">
            <h4>궁합이 좋은 유형</h4>
            <div className="d-flex flex-wrap gap-2">
              {result.compatibility.map((type, index) => (
                <span key={index} className="badge bg-success fs-6">{type}</span>
              ))}
            </div>
          </div>
          
          <div className="mb-4">
            <h4>추천 직업</h4>
            <div className="d-flex flex-wrap gap-2">
              {result.careers.map((career, index) => (
                <span key={index} className="badge bg-info fs-6">{career}</span>
              ))}
            </div>
          </div>
        </div>
        
        <div className="card-footer">
          <div className="d-grid gap-2">
            <button onClick={shareResult} className="btn btn-outline-primary">
              MBTI 테스트 공유하기
            </button>
            <Link to="/" className="btn btn-primary">
              테스트 다시 하기
            </Link>
          </div>
        </div>
      </div>
      
      {/* 광고 배너 영역 */}
      <div className="ad-container my-4 text-center">
        <AdBanner adSlot="3456789012" format="leaderboard" />
      </div>
    </div>
  );
}

export default ResultPage;